import * as yup from "yup";

export const LocationAddValidation = yup.object({
    locationName: yup.string().min(3).max(25).required(),
});
